<template>
  <div class="main">
    <router-link to="/act1/main">
      <div class="main" style="background-image:url(static/img/index/act-1-2.jpg?v=2)" >
        <img class="act-1-btn-book fen-up-down" src="static/img/act/1/btn-book.png" />
        <img class="act-1-cloud" src="static/img/act/1/cloud.png" />       
      </div>
    </router-link>    
  </div>
</template>
 

<script>

export default {
  name: "Act4Banner",
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {},
  created() {
    this.setDocumentV2(
      "2019春节闲游宝典",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/img/share.jpg?v=2"
    );
    _czc.push(['_trackEvent', '2019春节闲游宝典', '点击', 'Banner页面','0','1']);
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden
} 



.fen {
  pointer-events: auto;
  -webkit-user-select: auto;
}

@-webkit-keyframes frames-up-down {
  0% {
    -webkit-transform: translateY(-10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(-10px));
    -moz-transform-origin: top center;
    transform: translateY(-10px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateY(10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(10px);
    -moz-transform-origin: top center;
    transform: translateY(10px);
    transform-origin: top center;
  }
}

@keyframes frames-up-down {
  0% {
    -webkit-transform: translateY(-10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(-10px));
    -moz-transform-origin: top center;
    transform: translateY(-10px);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateY(10px);
    -webkit-transform-origin: top center;
    -moz-transform: translateY(10px);
    -moz-transform-origin: top center;
    transform: translateY(10px);
    transform-origin: top center;
  }
}

.fen-up-down {
  -webkit-animation: frames-up-down 2000ms ease-in-out alternate infinite;
  -moz-animation: frames-up-down 2000ms ease-in-out alternate infinite;
  animation: frames-up-down 2000ms ease-in-out alternate infinite;
  animation-delay: 360ms;
  -webkit-animation-delay: 360ms;
}


.boats-up-down {
  -webkit-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  -moz-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation-delay: 260ms;
  -webkit-animation-delay: 260ms;
}

.go-up-down {
  -webkit-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  -moz-animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation: frames-up-down 3300ms ease-in-out alternate infinite;
  animation-delay: 260ms;
  -webkit-animation-delay: 260ms;
}

/*  粉   end */


  .conents-loading{
    position: fixed !important;
    z-index: 4 !important;
    }
   .article-components .van-loading--white {
    padding: 10px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, .5);
    margin: auto;
    margin-top: 55%;
    margin-left: 43%;
}
  .search-form-wrap .van-icon-clear{
        right: 16%;
  }
  
   .go{
	 	position: absolute;
	 	right: 27px;
	 	top:38%;
 		width: 65.8%;
 		max-width: 600px;
 }
   .act-1-cloud{
    position: absolute;
       width: 33%;
    right: -11%;
    top: 34%;
    max-width: 600px;
 }
 
   .act-1-btn-book{
    position: absolute;
      width: 15%;
    right: 2px;
    top: 26.5%;
    max-width: 600px;
 }
	 .new-list-wrap .van-cell__value,.new-menu .van-cell{
		font-size: 15px;
		font-weight: bold;
		padding: 0.275rem 0;		
		/*margin-bottom: 0.55rem;*/ 
	}
	 
 
 
	  .new-list-wrap  .van-col:nth-child(even) {
    /*background-color: #66c6f2;*/
} 
  .new-list-wrap  .van-col {
    color: #fff;
    font-size: 13px;
    line-height: 30px;
    text-align: center;
    margin-bottom: 10px;
    background-clip: content-box;
}
   .new-list-wrap .van-col:nth-child(odd) {
    /*background-color: #39a9ed;*/
}

 
  .news-list-title .van-cell{
 	padding-top: 0;
 	padding-left: 0;
 	padding-bottom: 0 !important;
 }
 
 .news-list-more{
 height: 0.78rem;
 line-height: 0.9rem;
 width: 100%;
 text-align: center;
 font-size: 0.32rem;
 border-top: 0.2rem solid #e8e9eb;
}
   .news-list-more-down{
    display: inline-block;
    width: 3.4%;
    margin-left: 5px;
    vertical-align: middle;
    transform:rotate(0deg) translateX(0px);
    -webkit-transform: rotate(0deg) translateX(0px);
    -webkit-transition: 250ms;
    transition: 250ms;
    transition-timing-function:  ease;
    -webkit-transition-timing-function:  ease; 
  }
 
</style>


// WEBPACK FOOTER //
// src/components/act/1/Banner.vue